import * as moment from "moment";
import {JobEventApiDto, JobWatcherEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {getUser} from "../../../store/view/user";
import JobEvent, {JobEventTypeEnum} from "./JobEvent";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import _ = require("underscore");

/**
 * Job watcher changed event.
 */
export default class JobWatcherEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 * @param {JobWatcherEventData} data job watcher change event data.
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobWatcherEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobWatcherEvent {
		const data = JobWatcherEventData.fromJson(json.data as JobWatcherEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobWatcherEvent(json.id, json.jobId, JobEventTypeEnum.WatchersChanged, entity, moment(json.createdAt),
			json.referenceNumber, data);
	}

	getIcon() {
		return this.isWatcherRemoved() ? Icon.X : Icon.Watch;
	}

	getActivityMessage(): string {
		return this.getWatchersMessage();
	}

	/**
	 * Get changed watchers message.
	 * @return {string}
	 */
	getWatchersMessage() {
		const added = _.difference(this.data.currentWatchers, this.data.previousWatchers);
		const removed = _.difference(this.data.previousWatchers, this.data.currentWatchers);
		let toReturn = "";

		if (added.length) {
			toReturn = (this.getJoinedUserDisplayNames(added) + " added to watchers")
		}
		if (removed.length) {
			if (added.length) {
				toReturn += " / "
			}
			toReturn += (this.getJoinedUserDisplayNames(removed) + " removed from watchers")
		}
		return toReturn;
	}

	getJoinedUserDisplayNames(userIds: string[]): string {
		return userIds.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("")).join(", ");
	}

	/**
	 * Indicates if watcher has been removed.
	 * @return {boolean}
	 */
	isWatcherRemoved() {
		return (this.data.currentWatchers.length - this.data.previousWatchers.length) < 0;
	}
}


export class JobWatcherEventData {
	constructor(public readonly previousWatchers: string[],
		public readonly currentWatchers: string[]) {}

	public static fromJson(json: JobWatcherEventDataApiDto): JobWatcherEventData {
		return new JobWatcherEventData(json.previous, json.current);
	}
}
